import React, { useState, useEffect } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import DatePicker from 'react-date-picker';
import Calendar from 'react-calendar';
import { ToastContainer, toast } from 'react-toastify';
import '../../css/yemae.css';
// import "react-date-picker/dist/DatePicker.css";
// import "react-calendar/dist/Calendar.css";
import '../../css/calendar.css';
import axios from 'axios';
import moment from 'moment';
import { loadTossPayments } from '@tosspayments/payment-sdk';
import { Modal } from 'react-responsive-modal';
import { isMobile } from 'react-device-detect';

const Event20240910_popup_02 = (props) => {
  const { history, imgUrl } = props;
  const _reserve = () => {
    const today = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');

    // if (today < '2023-11-21 10:00:00') {
    //   toast.warn('예매가 시작전입니다.');
    //   return;
    // }

    if (today > '2024-01-07 18:00:00') {
      toast.warn('예매가 종료되었습니다.');
      return;
    }
    history.push('/reserve');
  };
  const _reserveList = () => {
    const today = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');

    // if (today < '2023-11-21 10:00:00') {
    //   toast.warn('예매가 시작전입니다.');
    //   return;
    // }
    history.push('/reserveList');
  };
  const _onBack = () => {
    history.goBack();
  };
  const _goNaver = () => {
    window.open(
      'https://booking.naver.com/booking/12/bizes/445544/items/6175432?preview=1&tab=book',
      '',
      ''
    );
  };
  return (
    <>
      <div>
        <div className="event_head">
          <h3>앙사블 스타즈!!! 3주년 전시회</h3>
          {isMobile && (
            <button
              type="button"
              className="btnClose"
              onClick={_onBack}
              style={{ pointer: 'cursor' }}
            >
              <img src={'/img/detail_img/close_1.png'} alt="닫기" />
            </button>
          )}
        </div>
        <div className="eventCon">
          <div className="event220916_2">
            <div>
              <img
                src={'/img/event/event20240910_popup_02/topimg.png'}
                usemap="#image-map1"
              />
            </div>
            <div>
              <a name="01"></a>
              <img src={'/img/event/event20240910_popup_02/img01.png'} />
            </div>
            <div>
              <a name="02"></a>
              <img src={'/img/event/event20240910_popup_02/img02.png'} />
            </div>
            <div>
              <a name="03"></a>
              <img src={'/img/event/event20240910_popup_02/img03.png'} />
            </div>
            <div>
              <img src={'/img/event/event20240910_popup_02/bottom.png'} />
            </div>

            {isMobile ? (
              <div
                // className="btm_bar"
                style={{
                  position: 'fixed',
                  // left: '15%',
                  width: '100%',
                  bottom: 60,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  // paddingRight: 50,
                }}
              >
                <div
                  style={{ display: 'flex', justifyContent: 'center' }}
                  onClick={_goNaver}
                >
                  <img src={'/img/page_btn.png'} />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <map name="image-map1">
        <area
          target="_blank"
          alt="오시는길"
          title="오시는길"
          href="https://www.ehyundai.com/newPortal/DP/WC/WC000000_V.do?branchCd=B00140000"
          coords="760,458,935,515"
          shape="rect"
        />
      </map>
      <map name="image-map">
        <area
          target=""
          alt="특전"
          title="특전"
          href="#01"
          coords="56,91,581,209"
          shape="rect"
        />
        <area
          target=""
          alt="자체굿즈"
          title="자체굿즈"
          href="#02"
          coords="607,88,1134,206"
          shape="rect"
        />
        <area
          target=""
          alt="수입굿즈"
          title="수입굿즈"
          href="#03"
          coords="1157,88,1684,206"
          shape="rect"
        />
      </map>

      {/* <div style={{ backgroundColor: '#fff' }}>
        <div onClick={_reserve}>예매하기</div>
        <div onClick={_reserveList}>예매목록</div>
      </div> */}
    </>
  );
};

export default shopContext(withRouter(Event20240910_popup_02));
